import { render, staticRenderFns } from "./feed-instagram-23-idees-et-exemples-de-feed.vue?vue&type=template&id=22809658&"
import script from "./feed-instagram-23-idees-et-exemples-de-feed.vue?vue&type=script&lang=js&"
export * from "./feed-instagram-23-idees-et-exemples-de-feed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports